export default {
  quizId: "",
  orgSlug: "",
  organizationId: "",
  validationType: "",
  quizCompleted: false,
  quizData: {},
  courseDetails: {},
  currentQuizIndex: -1,
  conversationData: [],
};
